import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const WarningHeader = () => {
  const navigate = useNavigate();
  const isMenuOpen = useSelector((state)=>state.sidebar.isMenuOpen);
  const userRole = useSelector((state) => state.user.role);
  const userStep = useSelector((state) => state.user.step);

  // Check if the user has not completed the registration process
  const shouldShowWarning = 
  (userRole === "user" && userStep < 2) || 
  ((userRole === "individual" || userRole === "organization") && userStep < 3);
// Example: Assuming step 2 means registration complete
  console.log("shouldShowWarning:", shouldShowWarning);

  const handleRedirect = () => {
    // Redirect based on the user's role to the registration page

    if (userRole !== "user" && userStep === 1) {
      navigate("/register");
    } else if (userRole === "individual" && userStep === 2) {
      navigate("/onboarding/userdocuments");
    } else if (userRole === "admin" && userStep === 2) {
      navigate("/onboarding/ngodocuments");
    }
  };

  if (!shouldShowWarning) return null; // Don't show if registration is complete

  return (
    <div className={`${isMenuOpen?"ml-64 w-96":"ml-0 " }w-full transition-all duration-300  bg-red-700 text-black py-1 px-3 flex justify-between items-center fixed bottom-0 left-0 right-0 z-50 rounded-md rounded-b-none `}>
      <div className="flex items-center">
        <span className="font-bold text-lg flex items-center">
          <span className="  animate-grow-shrink  mr-2">⚠️</span> Warning:
        </span>

        <span className="ml-2">
          You have not completed the registration process. Kindly complete it.
        </span>
      </div>
      <button
  onClick={handleRedirect}
  className="bg-blue-600 text-white font-semibold px-4 py-2 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors duration-300"
>
  Complete Registration
</button>

    </div>
  );
};

export default WarningHeader;
